import React from "react";
import { signalMeta } from "@/lib/signal";
import { TrendingUp, Pause, OctagonX } from "lucide-react";

export const SignalBadge = ({ signal, size = "md", className = "" }) => {
  const m = signalMeta(signal);
  const sizeCls = size === "lg" ? "text-base px-4 py-2" : "text-xs px-2.5 py-1";
  const Icon = signal === "scale" ? TrendingUp : signal === "stop" ? OctagonX : Pause;
  return (
    <span
      data-testid={`signal-badge-${(signal || "hold").toLowerCase()}`}
      className={`signal-pill ${m.className} ${sizeCls} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {m.label}
    </span>
  );
};

export default SignalBadge;
